export default __webpack_public_path__ + "static/media/barchart.68db9f2c.svg";